
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5429',
  depVersions: {
  "data-privacy-request-ui": "static-1.5429",
  "data-fetching-client": "static-1.9578",
  "head-dlb": "static-1.4938",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7915",
  "hub-http-shared-msw-handlers": "static-1.9736",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11358",
  "I18n": "static-7.1603",
  "jasmine-runner": "static-1.6371",
  "privacy-center-public-service-types": "static-1.4692",
  "quartz": "static-1.6873",
  "react-dlb": "static-1.77",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5496",
  "UIComponents": "static-3.8305",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.84",
  "foundations-assets": "static-1.4752",
  "foundations-components": "static-1.7728",
  "foundations-components-test-utils": "static-1.5211",
  "foundations-theming": "static-1.4316",
  "hub-http": "static-1.6122",
  "quartz-config": "static-1.651",
  "quartz-core": "static-1.6092",
  "quick-fetch": "static-1.3838",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-rhumb": "static-1.16559",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11050",
  "usage-tracker": "static-1.7238",
  "usage-tracker-anonymous": "static-1.5655",
  "usage-tracker-core": "static-1.7088",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4049",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3328",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3150",
  "quartz-webpack": "static-1.3097",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "HeadJS": "static-2.735",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3026",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.4000",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "react-utils": "static-2.5270",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4227",
  "rpc-client-utils": "static-1.4547",
  "HubStyle": "static-2.11666",
  "ui-addon-draggable": "static-3.4672",
  "cssUtils": "static-1.770",
  "hs-story-utils": "static-1.9333",
  "icons": "static-2.639",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1130",
  "bend-plugin-foundations-components": "static-1.3997",
  "floating-ui": "static-1.54",
  "foundations-theming-specialty": "static-1.2032",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1540",
  "ui-fonts": "static-1.620",
  "foundations-components-legacy": "static-1.753",
  "bend-plugin-foundations-theming": "static-1.2799",
  "foundations-theming-base": "static-1.3301",
  "stylex": "static-1.30",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.819",
  "hubspotter-http": "static-1.4574",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.548",
  "quartz-head": "static-1.538",
  "quartz-i18n": "static-1.548",
  "quartz-routing": "static-1.303",
  "quartz-test": "static-1.548",
  "quartz-tracking": "static-1.252",
  "usage-tracker-container": "static-1.7228",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3063",
  "chirp-fetch": "static-1.1784",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.68",
  "sassPrefix": "static-1.154",
  "hubspotter-http-shared-msw-handlers": "static-1.9734",
  "usage-tracker-session-replay": "static-1.4924",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5429",
  "data-fetching-client": "/data-fetching-client/static-1.9578",
  "head-dlb": "/head-dlb/static-1.4938",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7915",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9736",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11358",
  "I18n": "/I18n/static-7.1603",
  "jasmine-runner": "/jasmine-runner/static-1.6371",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4692",
  "quartz": "/quartz/static-1.6873",
  "react-dlb": "/react-dlb/static-1.77",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5496",
  "UIComponents": "/UIComponents/static-3.8305",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "foundations-assets": "/foundations-assets/static-1.4752",
  "foundations-components": "/foundations-components/static-1.7728",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5211",
  "foundations-theming": "/foundations-theming/static-1.4316",
  "hub-http": "/hub-http/static-1.6122",
  "quartz-config": "/quartz-config/static-1.651",
  "quartz-core": "/quartz-core/static-1.6092",
  "quick-fetch": "/quick-fetch/static-1.3838",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-rhumb": "/react-rhumb/static-1.16559",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11050",
  "usage-tracker": "/usage-tracker/static-1.7238",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5655",
  "usage-tracker-core": "/usage-tracker-core/static-1.7088",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3328",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3150",
  "quartz-webpack": "/quartz-webpack/static-1.3097",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "HeadJS": "/HeadJS/static-2.735",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3026",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.4000",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "react-utils": "/react-utils/static-2.5270",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4227",
  "rpc-client-utils": "/rpc-client-utils/static-1.4547",
  "HubStyle": "/HubStyle/static-2.11666",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4672",
  "cssUtils": "/cssUtils/static-1.770",
  "hs-story-utils": "/hs-story-utils/static-1.9333",
  "icons": "/icons/static-2.639",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1130",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3997",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2032",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1540",
  "ui-fonts": "/ui-fonts/static-1.620",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.753",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2799",
  "foundations-theming-base": "/foundations-theming-base/static-1.3301",
  "stylex": "/stylex/static-1.30",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.819",
  "hubspotter-http": "/hubspotter-http/static-1.4574",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.548",
  "quartz-head": "/quartz-head/static-1.538",
  "quartz-i18n": "/quartz-i18n/static-1.548",
  "quartz-routing": "/quartz-routing/static-1.303",
  "quartz-test": "/quartz-test/static-1.548",
  "quartz-tracking": "/quartz-tracking/static-1.252",
  "usage-tracker-container": "/usage-tracker-container/static-1.7228",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chirp-fetch": "/chirp-fetch/static-1.1784",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.68",
  "sassPrefix": "/sassPrefix/static-1.154",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9734",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4924",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
